import {
  getActivePlan,
  getCreditBalance,
  getCreditTotals,
  getLedgerEntries,
  type ActivePlan,
  type LedgerEntry,
} from "@super-resume-new/api/lib/credits";
import { createServerFn } from "@tanstack/react-start";

import { authMiddleware } from "@/middleware/auth";

export type { ActivePlan, LedgerEntry };

const PAGE_SIZE = 20;

export const getLedger = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }) => {
    if (!context.session?.user?.id) {
      return {
        entries: [] as LedgerEntry[],
        balance: 0,
        totalResumeTailor: 0,
        totalAtsBooster: 0,
        totalGranted: 0,
        nextCursor: null as number | null,
        activePlan: null as ActivePlan | null,
      };
    }
    const userId = context.session.user.id;
    const [rows, balance, totals, activePlan] = await Promise.all([
      getLedgerEntries(userId, PAGE_SIZE + 1),
      getCreditBalance(userId),
      getCreditTotals(userId),
      getActivePlan(context.headers),
    ]);
    const hasMore = rows.length > PAGE_SIZE;
    const entries = hasMore ? rows.slice(0, PAGE_SIZE) : rows;
    const last = entries[entries.length - 1];
    return {
      entries,
      balance,
      ...totals,
      nextCursor: hasMore && last ? (last.createdAt as Date).getTime() : null,
      activePlan,
    };
  });
